export default function header() {
  let searchPopup;
  $('.search-popup-trigger').each(function () {
    $(this).on('click', function () {
      $(this)
        .children()
        .each(function () {
          $(this).toggleClass('hidden');
        });

      if (!(searchPopup = $('#search-popup')) && !mobileMenu) return;
      searchPopup
        .toggleClass('invisible opacity-0')
        .css(
          'transition',
          searchPopup.hasClass('invisible')
            ? 'opacity .2s, visibility .2s'
            : 'opacity .2s'
        )
        .find("input[type='search']")
        .trigger('focus');
    });
  });

  let mobileMenu;
  $('#menu-mobile-trigger').on('click', function () {
    if (!(mobileMenu = $('#mobile-menu')) && !mobileMenu) return;
    $('body').toggleClass('overflow-hidden');

    mobileMenu.toggleClass('-translate-x-full');
    const { children } = this;
    $(children[0]).toggleClass('rotate-45 translate-y-3');
    $(children[1]).toggleClass('opacity-0');
    $(children[2]).toggleClass('-rotate-45 -translate-y-2');
  });
}
